<template>
    <div id="app">
        <h2>Collapse</h2>
        <a
            v-toggle.collapse
            href
            class="accordion-title"
            @click.prevent
        >
            OPEN
        </a>
        <collapse id="collapse">
            <p>Collapse content</p>
        </collapse>

        <h2>Collapse Accordion</h2>
        <a
            v-toggle.accordion1
            href
            class="accordion-title"
            @click.prevent
        >OPEN</a>
        <collapse
            id="accordion1"
            accordion="group"
        >
            <p>Accordion Item</p>
        </collapse>

        <a
            v-toggle.accordion2
            href
            class="accordion-title"
            @click.prevent
        >OPEN</a>
        <collapse
            id="accordion2"
            accordion="group"
        >
            <p>Accordion Item</p>
        </collapse>

        <a
            v-toggle.accordion3
            href
            class="accordion-title"
            @click.prevent
        >OPEN</a>
        <collapse
            id="accordion3"
            accordion="group"
        >
            <p>Accordion Item</p>
        </collapse>
    </div>
</template>

<script>

export default {
    name: 'App',
};
</script>

<style lang="less">
@import '~@/less/app.less';
</style>
